// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import AuthoringState from 'bundles/author-common/constants/AuthoringState';
import { CMLUtils } from 'bundles/cml';

const MarketingEmailsStore = createStore({
  storeName: 'MarketingEmailsStore',

  reset() {
    this.partnerId = null;
    this.marketingEmailsResponse = null;
    this.sentMarketingEmails = null;
    this.marketingEmailsPreviews = {};
    this.marketingEmailsAudienceCounts = {};
    this.editMode = true;
    this.saveState = AuthoringState.Idle;
    this.subjectEmpty = true;
    this.bodyEmpty = true;
    this.audienceEmpty = true;
    this.emailLimitReached = false;
    this.currentResponseId = null;
  },

  initialize() {
    this.reset();
  },

  getDraftId() {
    return this.marketingEmailsResponse ? this.marketingEmailsResponse.id.toString() : '';
  },

  getPartnerId() {
    return this.partnerId;
  },

  getEditMode() {
    return this.editMode;
  },

  getMarketingEmailsResponse() {
    return this.marketingEmailsResponse;
  },

  getMarketingEmailsPreview(marketingEmailId: $TSFixMe) {
    return this.marketingEmailsPreviews[marketingEmailId];
  },

  getMarketingEmailsPreviews() {
    return this.marketingEmailsPreviews;
  },

  getMarketingEmailsId() {
    return this.marketingEmailsResponse && this.marketingEmailsResponse.id;
  },

  getMarketingEmailsAudienceCounts() {
    return this.marketingEmailsAudienceCounts;
  },

  getSentMarketingEmails() {
    return this.sentMarketingEmails;
  },

  getCanPreview() {
    return !this.subjectEmpty && !this.bodyEmpty && !this.audienceEmpty;
  },

  getSaveState() {
    return this.saveState;
  },

  getEmailLimitReached() {
    return this.emailLimitReached;
  },

  getCurrentResponseId() {
    return this.currentResponseId || (this.emailResponse && this.emailResponse.id);
  },

  validate() {
    if (this.marketingEmailsResponse) {
      const marketingEmailsDefinition = this.marketingEmailsResponse.message.definition;

      this.subjectEmpty = marketingEmailsDefinition.payload.subject === '';
      this.bodyEmpty = CMLUtils.isEmpty(marketingEmailsDefinition.payload.content);
      this.audienceEmpty = marketingEmailsDefinition.audience.typeName === 'testUser';
    }
  },
});

MarketingEmailsStore.handlers = {
  RECEIVE_PARTNER_ID({ partnerId }: $TSFixMe) {
    this.partnerId = partnerId;
    this.emitChange();
  },

  RECEIVE_MARKETING_EMAILS({ marketingEmailsResponse }: $TSFixMe) {
    this.marketingEmailsResponse = marketingEmailsResponse;
    this.validate();
    this.emitChange();
  },

  RECEIVE_UPDATED_METADATA({ metadata }: $TSFixMe) {
    this.marketingEmailsResponse.metadata = metadata;
    this.saveState = AuthoringState.Idle;
    this.emitChange();
  },

  RECEIVE_HISTORY({ sentMarketingEmails }: $TSFixMe) {
    this.sentMarketingEmails = sentMarketingEmails;
    this.emitChange();
  },

  RECEIVE_MARKETING_EMAILS_PREVIEW({ marketingEmailsResponseId, html }: $TSFixMe) {
    this.marketingEmailsPreviews[marketingEmailsResponseId] = html;
    this.emitChange();
  },

  RECEIVE_MARKETING_EMAILS_AUDIENCE_COUNT({ marketingEmailsAudienceCounts }: $TSFixMe) {
    this.marketingEmailsAudienceCounts = marketingEmailsAudienceCounts;
    this.validate();
    this.emitChange();
  },

  EDIT() {
    this.editMode = true;
    this.emitChange();
  },

  PREVIEW() {
    this.editMode = false;
    this.marketingEmailsPreviews[this.getMarketingEmailsId()] = '';
    this.emitChange();
  },

  SHOW_SAVE_NOTIFICATION() {
    if (this.saveState.id !== AuthoringState.InProgress.id) {
      this.saveState = AuthoringState.InProgress;
      this.emitChange();
    }
  },

  UPDATE_AUDIENCE({ audience }: $TSFixMe) {
    this.marketingEmailsResponse.message.definition.audience.typeName = audience;
    this.saveState = AuthoringState.InProgress;
    this.validate();
    this.emitChange();
  },

  UPDATE_SUBJECT({ subject }: $TSFixMe) {
    this.marketingEmailsResponse.message.definition.payload.subject = subject;
    this.saveState = AuthoringState.InProgress;
    this.validate();
    this.emitChange();
  },

  UPDATE_BODY({ body }: $TSFixMe) {
    this.marketingEmailsResponse.message.definition.payload.content.definition = body.definition;
    this.saveState = AuthoringState.InProgress;
    this.validate();
    this.emitChange();
  },

  UPDATE_CURRENT_RESPONSE_ID({ responseId }: $TSFixMe) {
    this.currentResponseId = responseId;
    this.emitChange();
  },

  PUBLISH() {
    this.saveState = AuthoringState.PublishInProgress;
    this.emitChange();
  },

  PUBLISHED() {
    this.saveState = AuthoringState.Published;
    this.emitChange();
  },

  RESET_PARTNER_UPDATE() {
    this.saveState = AuthoringState.Idle;
    this.marketingEmailsResponse = null;
    this.editMode = true;
    this.emitChange();
  },

  CONFLICT() {
    this.saveState = AuthoringState.Conflict;
    this.emitChange();
  },

  ERROR() {
    this.saveState = AuthoringState.Error;
    this.emitChange();
  },

  EMAIL_LIMIT() {
    this.emailLimitReached = true;
    this.emitChange();
  },

  UNLOAD() {
    this.reset();
    this.emitChange();
  },
};

export default MarketingEmailsStore;
